import React from "react";

function IdentityPage({ pillars, dayStem, dayElemZh, strengthScore, strengthLabel, yongElem,
  xiElem, jiElem, chouElem, yongDesc, xiDesc, jiDesc, chouDesc,
  ELEM_EMOJI, _backend, _narratives, reportNumber, lang }) {

  const STEM_ELEM = {甲:"wood",乙:"wood",丙:"fire",丁:"fire",戊:"earth",己:"earth",庚:"metal",辛:"metal",壬:"water",癸:"water"};
  const ELEM_LABEL_EN = {wood:"Wood",fire:"Fire",earth:"Earth",metal:"Metal",water:"Water"};

  return (
    <div className="lr2-page" id="ch2">
      <div className="lr2-ph">
        <span className="lr2-ph-num">02</span>
        <div>
          <div className="lr2-ph-title">我是谁 · 能量底色</div>
          <div className="lr2-ph-sub">IDENTITY · CORE ENERGY PROFILE</div>
        </div>
      </div>
      <div className="lr2-section">
        <div className="lr2-st">日主能量画像</div>
        <div className="lr2-hero">
          <div className="lr2-hero-headline">{dayStem}{dayElemZh}日主 · {strengthLabel}格局</div>
          <div className="lr2-hero-row">
            <span className="lr2-hero-badge">强弱得分 <strong>{Math.round(strengthScore)} / 100</strong></span>
            {yongElem && <span className="lr2-hero-badge">用神 <strong>{yongElem}</strong></span>}
            {xiElem && <span className="lr2-hero-badge">喜神 <strong>{xiElem}</strong></span>}
            {jiElem && <span className="lr2-hero-badge">忌神 <strong>{jiElem}</strong></span>}
          </div>
          <div className="lr2-hero-body">
            {(_backend?.identity_narrative || _backend?.narrative_sections?.life_theme || "").split(/\n+/).filter(Boolean).map((para,i)=>(
              <p key={i}>{para}</p>
            ))}
            {!(_backend?.identity_narrative || _backend?.narrative_sections?.life_theme) && (
              <p>{lang==="zh"
                ? `你的命盘以 ${dayStem}${dayElemZh} 日主为核心，呈现${strengthLabel}格局——这意味着你在日常里有 3 个具体模式：你给出去的能量是什么类型、你最容易枯竭的场景在哪里、什么样的环境会让你重新有劲。这份命盘还藏着 3 个影响你今年决策的关键信号，需要逐个拆开来看。`
                : `Your chart centers on ${dayStem||"—"} (${ELEM_LABEL_EN[STEM_ELEM[dayStem]]||"—"}) day master with a ${strengthLabel} pattern. Download the LUMINAARC Pro PDF for the full narrative.`}</p>
            )}
          </div>
        </div>
      </div>
      {_narratives?.daymaster_analysis && (
        <div className="lr2-section">
          <div className="lr2-st">日主能量深度解读</div>
          <div style={{fontSize:"13.5px",color:"#333",lineHeight:1.9}}>
            {_narratives.daymaster_analysis.split("\n").filter(Boolean).map((para,i)=>(
              <p key={i} style={{marginBottom:10}}>{para}</p>
            ))}
          </div>
        </div>
      )}
      {(yongElem || xiElem) && (
        <div className="lr2-section">
          <div className="lr2-st">喜用忌仇神 · 四象能量方向</div>
          <div className="lr2-xy">
            <div className="lr2-xc yong">
              <div className="lr2-xc-role">用神 · 最需要补充</div>
              <div className="lr2-xc-elem">{yongElem||"—"}</div>
              <div className="lr2-xc-emoji">{ELEM_EMOJI[yongElem]||""}</div>
              <div className="lr2-xc-desc">{yongDesc}</div>
            </div>
            <div className="lr2-xc xi">
              <div className="lr2-xc-role">喜神 · 同类加强</div>
              <div className="lr2-xc-elem">{xiElem||"—"}</div>
              <div className="lr2-xc-emoji">{ELEM_EMOJI[xiElem]||""}</div>
              <div className="lr2-xc-desc">{xiDesc}</div>
            </div>
            <div className="lr2-xc ji">
              <div className="lr2-xc-role">忌神 · 消耗警惕</div>
              <div className="lr2-xc-elem">{jiElem||"—"}</div>
              <div className="lr2-xc-emoji">{ELEM_EMOJI[jiElem]||""}</div>
              <div className="lr2-xc-desc">{jiDesc}</div>
            </div>
            <div className="lr2-xc chou">
              <div className="lr2-xc-role">仇神 · 尽量回避</div>
              <div className="lr2-xc-elem">{chouElem||"—"}</div>
              <div className="lr2-xc-emoji">{ELEM_EMOJI[chouElem]||""}</div>
              <div className="lr2-xc-desc">{chouDesc}</div>
            </div>
          </div>
        </div>
      )}
      {(_backend?.personality_section || _backend?.narrative_sections?.personality_insight) && (
        <div className="lr2-section">
          <div className="lr2-st">性格深度洞察 · 十神解读</div>
          <div style={{fontSize:"13.5px",color:"#333",lineHeight:1.9}}>
            {(_backend.personality_section || _backend.narrative_sections?.personality_insight || "").split(/\n+/).filter(Boolean).map((para,i)=>(
              <p key={i} style={{marginBottom:14}}>{para}</p>
            ))}
          </div>
        </div>
      )}
      <div className="lr2-quote">
        「强弱不是优劣，而是起点的地形描述。偏弱格局者，往往是因为承担了太多、接受了太少——调整补给方向，而非否定自己的能量。」
        <cite>— 澄光能量 · 解读框架</cite>
      </div>
      <div className="lr2-pf"><span className="lr2-pf-label">澄光能量 · {reportNumber}</span><span className="lr2-pf-seal lr2-pf-current">2</span></div>
    </div>
  );
}

export default IdentityPage;
